import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'styles/main.css';

import React from 'react';
import ReactDOM from 'react-dom';
// import registerServiceWorker from './registerServiceWorker';
import {createStore, applyMiddleware} from 'redux';
import {composeWithDevTools} from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import {Provider} from 'react-redux';
import {syncHistoryWithStore} from 'react-router-redux';
import {Router, Route, browserHistory, Redirect} from 'react-router';
import { routerMiddleware } from 'react-router-redux';

import reducers from 'reducers';
import Card from 'pages/Card';
import NotFound from 'pages/NotFound';
import Promo from 'pages/Promo';
import PromoDetail from 'pages/PromoDetail';

const store = createStore(reducers, composeWithDevTools(
    applyMiddleware(thunk),
    applyMiddleware(routerMiddleware(browserHistory)),
));

const history = syncHistoryWithStore(browserHistory, store);

ReactDOM.render(
        <Provider store={store}>
            <Router history={history}>
                <Route path='/en' component={Promo} />
                <Route path='/en/:id' component={PromoDetail} />
                <Route path='/expo/uniti2018/:uid' component={Card} />
                <Route path='/404' component={NotFound} />
                <Redirect from='*' to='/404' />
            </Router>
        </Provider>
    , document.getElementById('root'));
// registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js